export default {
    data: () => ({
        items: {
            activity: [],
            speaker: [],
            location: [],
            staticItem: [],
            gift: [],
        }
    }),

    mounted() {
        this.setList();
    },
    methods: {
        setList() {
            let list = JSON.parse(localStorage.getItem(`ttpe-list`)) || {}

            Object.keys(this.items).forEach(key => {
                if (list.hasOwnProperty(key)) this.items[key] = list[key].filter((item, index, self) =>
                    index === self.findIndex((a) => (a.ID === item.ID && a.id === item.id))
                )
            });
        }
    }
}